import { render, staticRenderFns } from "./ListBuildingSchedules.vue?vue&type=template&id=edbbdcbe"
import script from "./ListBuildingSchedules.vue?vue&type=script&lang=js"
export * from "./ListBuildingSchedules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports